module.exports = __webpack_public_path__ + "img/diseno_msh.e8f9d3fc.jpg";